import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Button } from '@figure/frontlib-gui';
import { PageHeader } from 'shared/components/Typography';
import { useRedirect } from 'shared/hooks';

const TextWrapper = styled.div`
  margin-bottom: 36px;
`;
const ButtonGroup = styled.div`
  text-align: center;

  > :first-child {
    margin-right: 16px;
  }
`;

const UploadHoldingScreen = ({ type, plUuid }) => {
  const { redirectToDashboard } = useRedirect();
  const headerTextMap = {
    paystub: 'We are reviewing your paystub and will let you know when you can proceed with your application.',
  };

  const handleDashboardClick = () => redirectToDashboard();

  return (
    <>
      <PageHeader>{headerTextMap[type]}</PageHeader>
      <TextWrapper>
        <p>
          Thank you for uploading your paystub. We are reviewing what you provided and will let you know if we are able to verify your
          income or if we need to collect an additional paystub. This process may take a couple of days.
        </p>
        <p>
          To expedite this process and continue your application immediately, you can connect an additional income source using one of
          our automated methods by selecting ‘Connect New Source’ below. Otherwise, we will notify you when your paystub has been
          processed and you can proceed.
        </p>
      </TextWrapper>

      <ButtonGroup>
        <Button to={`/applications/${plUuid}/income/review`} semanticElement={Link}>
          Connect New Source
        </Button>
        <Button onClick={handleDashboardClick} primary semanticElement={'a'}>
          Dashboard
        </Button>
      </ButtonGroup>
    </>
  );
};

UploadHoldingScreen.propTypes = {
  type: PropTypes.string.isRequired,
  plUuid: PropTypes.string.isRequired,
};

export default UploadHoldingScreen;
